<div class="md-form" *ngIf="vm">

    <ng-template #popTemplate>
        <div>
            <span>{{vm.helpText}}</span>
        </div>
        <div *ngIf="validationErrors.length">
            <p class="text-danger" *ngFor="let ve of validationErrors">{{ve}}</p>
        </div>
    </ng-template>

    <input type="search" mdbInput [ngModel]="text" (ngModelChange)="modelChanged($event)"
        [required]="vm.isRequired" [id]="vm.elementId" [name]="vm.elementId" 
        [disabled]="vm.isLocked || initializing || autoCompleteDisabled"
        [readonly]="vm.isLocked || initializing || autoCompleteDisabled"
        [attr.autocomplete]="inputAutocomplete"
        class="completer-input form-control mdb-autocomplete" [mdbAutoCompleter]="auto"
        (clearBtnClicked)="cleared(vm)" />
    <mdb-auto-completer #auto="mdbAutoCompleter" 
        [displayValue]="onDisplayValue" [textNoResults]="noResultsText" [clearButton]="!vm.isLocked"
        [disabled]="autoCompleteDisabled || initializing"
        (selected)="itemSelected(vm, $event)">
        <mdb-option *ngFor="let option of results | async" [value]="option">
            <div class="d-flex flex-column">
                {{option.code}} - {{option.name}}
            </div>
        </mdb-option>
    </mdb-auto-completer>

    <label [for]="vm.elementId" style="cursor: pointer;" [mdbPopoverHeader]="vm.title" [mdbPopover]="popTemplate"
        triggers="hover">{{vm.title}}
        <mdb-icon *ngIf="validationErrors.length" class="text-danger" fas icon="exclamation-circle"></mdb-icon>
        <mdb-icon *ngIf="vm.isLocked" style="color: #e0e0e0;" fas icon="lock"></mdb-icon>
    </label>

</div>